import React from 'react'
import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { ExplorePageProps } from 'types/page'
import { ContentfulProducts, ROUTES } from 'parameters'
import { explorePageInitialProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import StudentLoanRefinancePage from 'experiences/products/StudentLoanRefinancePage'
import { ProductConstraint } from 'services/ContentfulService/constraints'

const StudentLoanRefinance: NextPage<PagePropsWrapper<ExplorePageProps>> = ({
	metaTags,
	pageProps: { articles }
}): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<StudentLoanRefinancePage articles={articles} />
	</StandardLayout>
)

StudentLoanRefinance.getInitialProps = explorePageInitialProps(
	ROUTES.STUDENT_LOAN_REFINANCE,
	ProductConstraint(ContentfulProducts.SLR)
)

export default StudentLoanRefinance
